import { SxProps, Theme } from '@mui/material';

export const AccountPersonalFrameSX: SxProps<Theme> = (theme) => ({
	display: 'grid',
	maxWidth: '50%',
	[theme.breakpoints.down('md')]: {
		maxWidth: '100%',
	},
	gap: theme.spacing(4),
});

export const AccountPersonalButtonSX: SxProps = {
	fontSize: 'var(--font-size-body)',
	borderRadius: 50,
	marginTop: 2,
	'&.Mui-disabled': {
		backgroundColor: 'gray',
		color: '#ffffff',
		opacity: 0.5,
	},
};

export const AccountPersonalTextFieldSX: SxProps = {
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'& .MuiOutlinedInput-root': {
		'&:hover fieldset': {
			borderColor: '#C9C9C9',
		},
		'&.Mui-focused fieldset': {
			borderColor: '#0467D2',
		},
	},
};

export const AccountSelectSX: SxProps = {
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#C9C9C9',
	},
	height: '48px',
	'.MuiOutlinedInput-root': {
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	'.MuiOutlinedInput-notchedOutline': {
		borderColor: '#C9C9C9',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#0467D2',
	},
	'& .MuiSelect-iconOpen': {
		transform: 'none',
	},
};
